<template>
	<div class="addcargostuff" v-if="isload" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-card class="box-card" shadow="hover">
			<div slot="header" class="clearfix">
				<span>{{infolang.basetitle }}</span>
			</div>
			<el-form :inline="true" size="mini" label-width="120">
				<el-form-item :label="infolang.a_type">
					<el-input v-model="orderinfo.a_type" :disabled="curpkval!=''"></el-input>
				</el-form-item>
				<el-form-item >
					<el-switch v-model="orderinfo.ismul" :active-text="infolang.mulchecked" 
					:inactive-text="infolang.singlechecked" active-value="1" inactive-value="0"
					 active-color="#72cb49"></el-switch>
				</el-form-item>
			</el-form>
			<pl-table :data="orderinfo.list" :header-cell-style="{ background: '#f5f5f5', color: '#606266', textAlign: 'center', paddingTop: '8px', paddingBottom: '8px' }"
		:cell-style="{ padding: '0px',height:'40px' }" style="width:70%">
				<pl-table-column
				      :label="infolang.a_name"
				      width="200">
				      <template slot-scope="scope">
				        <el-input v-model="scope.row.a_name" size="mini"></el-input>
				      </template>
				</pl-table-column>
				<pl-table-column
				      :label="infolang.isaddprice" align="center">
				      <template slot-scope="scope">
						  <el-switch v-model="scope.row.isaddprice" size="mini" :active-text="infolang.addprice"
  :inactive-text="infolang.normalprice" active-color="#72cb49" active-value="1" inactive-value="0" 
  ></el-switch>
				      </template>
				</pl-table-column>
				<pl-table-column
				      :label="infolang.price"
				      width="200">
				      <template slot-scope="scope">
				        <el-input v-model="scope.row.price" size="mini" type="number"></el-input>
				      </template>
				</pl-table-column>
				<pl-table-column
				      width="200">
				      <template slot-scope="scope">
						  <label style="margin-left:15px">
						  	<el-link type="primary" :underline="false" 
						  	@click="addstuff(scope.$index)">
						  		{{ $lang.label.public.add}}
						  	</el-link>
						  </label>
						  <label style="margin-left:15px" v-if="scope.$index>0">
						  	<el-link type="danger" :underline="false" 
						  	@click="removestuff(scope.$index)">
						  		{{ $lang.label.public.del}}
						  	</el-link>
						  </label>						  
				       </template>
				</pl-table-column>
			</pl-table>
		</el-card>
		<el-card class="box-card" shadow="hover">
			<div slot="header" class="clearfix">
				<span>{{infolang.linkcargotitle }}</span>
			</div>
			<div style="height:40px;">
				<el-button size="mini" type="success" plain @click.native="openselectcargo">{{infolang.addcargo}}</el-button>
			</div>
			<tableui
				style="width:100%;"
				v-loading="loading"
				ref="linkcargo"
				:tableData="linkcargolist"
				:columns="linkcolumns"
				@gridhandle="gridhandle"
				:gridheight="gridheight"
			></tableui>
		</el-card>
		<el-row class="footerhandler" v-if="!btndisabled">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="saveinfo">{{$lang.label.public.savebtn}}</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">{{$lang.label.public.cancel}}</div></el-col>
		</el-row>
		<dialogwin ref="dialogwin" @dialogsrue="dialogsrue"></dialogwin>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import dialogwin from '@/components/tools/dialogwin.vue';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui,
		dialogwin
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			divclass:'addcargostuff',
			infolang:{},
			curpkval:'',
			linkcolumns:[
				{ field: 'cno', title: '商品条码', type: 'text', width: '120', sortable: false },
				{ field: 'cname', title: '商品名称', type: 'text', width: '120', sortable: false },
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '100',
					sortable: false,
					template: [
						{ type: 'button', title:this.$lang.label.public.del,  handletype: 'danger', event: 'delcargo' }
					]
				}],
			isload:false,
			loading:false,
			linkcargolist:[],
			gridheight:(window.innerHeight-120-350)+'px',
			windowHeight: window.innerHeight - 120,
			btndisabled:false,
			t_id:'',
			orderinfo:
			{
				a_type:'',
				cargo_id:'',
				ismul:"0",
				list:[
					{a_name:'',isaddprice:"0",price:0}
				]
			},
			type:'附加需求管理',
			pagetranscol:'',
			l_id:''
		}
	},
	created() {
		//debugger
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/baseinfo/addcargostuff.scss');
		this.init();
	},
	methods:{
		init(){
			debugger
			this.isload=false;
			if (this.urlparam != undefined) {
				this.type=this.item.l_tablename;
				if (this.urlparam.pkval != undefined) {
					this.curpkval = this.urlparam.pkval;
				}
			}
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('cargostuff',this).then(res=>{
				//debugger
				if(res.state=='1')
				{
					that.infolang=that.$lang.label.cargostuff;
					that.linkcolumns.forEach(e=>{
						if(that.infolang[e.title]!=undefined)
							e.title=that.infolang[e.title];
					});
					that.isload=true;	
				}	
				if(that.curpkval!='')//加载口味详情
					that.GetOrderInfo();
				else
					that.GetPageLayout();
			});
		},
		//获取口味组信息
		GetOrderInfo(){
			var that=this;
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			var paraminfo={
				pkval:this.curpkval,
				l_id:this.l_id
			}
			this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					debugger
					if(res.main!=undefined){
						if(res.main.linkcargolist!=undefined){
							if(res.main.linkcargolist!='')
							{
								that.linkcargolist=JSON.parse(res.main.linkcargolist);
								delete res.main.linkcargolist;
							}
						}
						if(res.main.list!=undefined){
							if(res.main.list!='')
								res.main.list=JSON.parse(res.main.list);
						}
						that.orderinfo=res.main;
					}
					that.GetPageLayout();
				} else
					this.$tool.message(that.$lang.label.public.getinfofailed, "0");
			});
		},
		GetPageLayout(){
			var that = this;
			//this.truncatepage();
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			debugger
			//判断是哪种类型的下单功能,显示对应组件
			this.$apipost.get.GetTransFormat({
				p_mode: this.type
			}).then(res => {
				debugger
				this.$tool.loadingclose();
				var t_id="",pagetranscol="";
				if (res.state == '1') {
					if (res.set != undefined) {
						if(res.set.t_id!=undefined)
						{
							t_id = res.set.t_id;
							pagetranscol=res.set.pagetranscol;
						}
					}
				}
				that.t_id=t_id;
				that.pagetranscol=pagetranscol;
			});
		},
		//保存口味组信息
		saveinfo(){
			//debugger
			var that=this;
			if(this.orderinfo.a_type==''){
				that.$tool.message(that.infolang.atypeempty, 0);
				return false;
			}
			var orderinfo=this.orderinfo;
			//var list=[];
			
			// if(orderinfo.cargo_id!='')
			//    orderinfo.cargo_id=orderinfo.cargo_id.substring(0,orderinfo.cargo_id.length-1);

			if(orderinfo.list.length>0){
				orderinfo.editid=this.curpkval;
				orderinfo.t_id=that.t_id;
				orderinfo.p_mode=this.type;
				this.orderinfo=orderinfo;
				//debugger
				orderinfo=that.$tool.TransOrderInfo(this.pagetranscol, that);
				//debugger
				this.btndisabled=true;
				this.$tool.loading(that.$lang.label.public.saving, this.divclass);
				this.$apipost.post.SaveInfo({ paraminfo:orderinfo }).then(res => {
					this.$tool.loadingclose();
					this.btndisabled=false;
					if (res.state == '1') {
						this.$tool.message(that.$lang.label.public.savesuccess, "1");
						setTimeout(function(){
							that.cancel();
						},200);
					}
					else
						this.$tool.message(res.message, "0");
						//this.$tool.message(that.$lang.label.xunjia_lang[res.message], "0");
				});
			}
		},
		cancel(){
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		openselectcargo(){
			var that=this;
			this.$apipost.get.GetLinkInfo({ l_id:576 }).then(res => {
				//debugger
				if (res.info != undefined) {
					var paramitem=res.info;
					paramitem.iswin=true;
					that.$refs.dialogwin.init({item:paramitem,title:that.infolang.selectcargo});
				} else that.$tool.message('此功能无法启用', 0);
			});
		},
		dialogsrue(e){
			//debugger
			//读取商品
			var that=this;
			if(e.l_id==576){
				if(e.rows!=undefined)
				{
					
					e.rows.forEach(r=>{
						var isexists=that.linkcargolist.filter(function(c){
							return c.cargoid==r.pkval;
						});
						//debugger
						if(isexists.length==0){
							that.linkcargolist.push({cname:r.cname,cno:r.cno,cargoid:r.pkval});
							that.orderinfo.cargo_id+=r.pkval+',';
						}
					});
				}
			}
		},
		gridhandle(e){
			if (e.event == 'delcargo') {
				this.orderinfo.cargo_id=this.orderinfo.cargo_id.replace(this.linkcargolist[e.index].cargoid+',','');
				this.linkcargolist.splice(e.index,1);
			}
		},
		addstuff(index){
			this.orderinfo.list.splice(index+1,0,{a_name:'',isaddprice:false,price:0});
		},
		removestuff(index){
			if(this.orderinfo.list.length>1){
				this.orderinfo.list.splice(index,1);
			}
		}
	}
}	
</script>

<style>
</style>